import React, { Component } from "react";
import { Link } from "react-router-dom";
class CareesJobApplication_SiteContent extends Component {
  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div
            className="themesflat-carousel-box data-effect clearfix"
            data-gap={0}
            data-column={1}
            data-column2={1}
            data-column3={1}
            data-auto="true"
          >
            <div className="themesflat-headings style-2 clearfix">
              <h2 className="heading">PRIJAVE ZA POSAO</h2>
              <div className="sep has-width w80 accent-bg clearfix" />
              <p className="sub-heading font-size-16 line-height-28 text-666 margin-top-27 letter-spacing-01">
                Samo jedan klik smo udaljeni od upoznavanja. Nadamo se da se
                možeš pronaći u jednoj od otvorenih pozicija.
                <br />
                Prilikom slanja zatjeva, molimo te da pažljivo ispuniš formu, te
                provjeriš unesene podatke. Očekuj naš povratni poziv/mail uskoro
                ;)
              </p>
            </div>
            <div
              className="themesflat-spacer clearfix"
              data-desktop={22}
              data-mobile={22}
              data-smobile={22}
            />
          </div>
          <iframe
            src="https://forms.monday.com/forms/embed/2442c429161c8a32e95b783a4c461a10?r=use1"
            width={"100%"}
            style={{
              width: "100%",
              height: "1200px",
            }}
          ></iframe>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={78}
            data-mobile={60}
            data-smobile={60}
          />
        </div>
      </div>
    );
  }
}

export default CareesJobApplication_SiteContent;
